import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Chip,
  Paper,
  FormControlLabel,
  IconButton,
  Avatar,
  Tooltip,
} from "@material-ui/core";
import {
  CircularProgress,
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  FormControl,
  Switch,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,Input
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  CheckCircle,
  Block,
  Delete,
  Edit,
  AccountCircle,
  Close,
  PermIdentity,
  ArrowForwardIos,
  SubdirectoryArrowLeftOutlined,
  AccountBalance,
  Schedule,
  Money,
  VpnLock,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { makeStyles } from "@material-ui/styles";
import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
  Permissions,
} from "../../utils/web_config";
import { useSnackbar } from "notistack";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));



function AgentManagers(props) {
  const classes = useStyles();
  const history = useHistory();

  const ag = localStorage.getItem("nx_ag");

  const [accountData, setAccountData] = useState({});

  const [agents, setAgents] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    toggling: false,
    data: [],
  });

  const [selectedAgent, setSelectedAgent] = useState({
    saving: false,
    loading: false,
    data: {},
  });

  const [agentAccount, setAgentAccount] = useState({
    saving: false,
    loading: false,
    data: {},
  });



  const [status, setStatus] = useState("Loading agent managers...");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    var accountData =JSON.parse(ag);
    setAccountData(accountData);
 
    getAgents(accountData.token,accountData.organization.organization_id);
  }, []);



  ////////////////////////////////

  const columns = [
    {
      name: "user_id",
      label: "User id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "user_name",
      label: "Agent name",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "agent_code",
      label: "Agent code",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "user_email",
      label: "Email",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "user_phone",
      label: "Phone",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "user_gender",
      label: "Gender",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "user_type",
      label: "Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status2",
      label: "Status2",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "user_status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {agents.data[dataI].user_status.toLowerCase() == "enabled" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                agents.data[dataI].user_status.toLowerCase() == "enabled"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(agents.data[dataI]?.user_status)}
            />
          );
        },
      },
    },
  ];


  const options = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search agent...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    onCellClick: (cellData, cellMeta) => {
      var user = agents?.data[cellMeta.dataIndex];

    
      if (user.agent_code == null) {

        notify("error","This agent account has an issue, contact Centrika team for assistance");
        return;
      }else if(user==null){
        return
      }
     history.push("/agent/manager", user);
    },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: status,
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <Box
      />
    ),
  };

  const notify = (variant, msg, status) => {

    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  const getAgents = (token, id) => {
    const agentsInstance = axios.create(new AdminService().getHeaders(token));

    setAgents({ ...agents, loading: true });

    agentsInstance
      .get(new AdminService().GET_USERS_BY_ORGANIZATION_AND_TYPE+id+"/type/AGENT_MANAGER")
      .then(function (response) {
        setAgents({ ...agents, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setStatus("There are no managers available.");
        } else {
          var usrs = [];

          d.data.forEach((u, i) => {
            const newUser = u;
            newUser["status2"] = u.user_status;
            newUser["user_name"] = u.user_first_name + " " + u.user_last_name;

            usrs.push(u);
          });

          setAgents({
            ...agents,
            data: usrs,
          });
        }
      })
      .catch(function (error) {
        setAgents({ ...agents, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setStatus(e);

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////




  return (
    <div className={classes.root}>
      {/* Dialogs starts here */}

      

      {/* ////////////////////////// */}

      <Dialog
        open={selectedAgent.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setSelectedAgent({ ...selectedAgent, open: false })}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          {selectedAgent.data.user_first_name +
            " " +
            selectedAgent.data.user_last_name}{" "}
          account
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12} sm={5}>
              <Box display="flex" justifyContent="center" mt={2}>
                <Avatar style={{ height: 120, width: 120 }} />
              </Box>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <AccountCircle />
                  </ListItemIcon>
                  <ListItemText primary="Account number:" />
                  <ListItemSecondaryAction>
                    <Typography variant="subtitle1" color="textSecondary">
                      {agentAccount.data.account_number_formatted}
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>

                <ListItem>
                  <ListItemIcon>
                    <Schedule />
                  </ListItemIcon>
                  <ListItemText primary="Wallet expire:" />
                  <ListItemSecondaryAction>
                    <Typography variant="subtitle1" color="textSecondary">
                      {agentAccount.data.wallet_expiry_date}
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Money />
                  </ListItemIcon>
                  <ListItemText primary="Opening balance:" />
                  <ListItemSecondaryAction>
                    <Typography color="secondary">
                      <b>
                        {agentAccount.data.opening_balance}{" "}
                        {agentAccount.data.currency_code}
                      </b>
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <AccountBalance />
                  </ListItemIcon>
                  <ListItemText primary="Current balance:" />
                  <ListItemSecondaryAction>
                    <Typography color="primary">
                      <b>
                        {agentAccount.data.current_balance}{" "}
                        {agentAccount.data.currency_code}
                      </b>
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Money />
                  </ListItemIcon>
                  <ListItemText primary="Closing balance:" />
                  <ListItemSecondaryAction>
                    <Typography color="secondary">
                      <b>
                        {agentAccount.data.closing_balance}{" "}
                        {agentAccount.data.currency_code}
                      </b>
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <VpnLock />
                  </ListItemIcon>
                  <ListItemText primary="Account status:" />
                  <ListItemSecondaryAction>
                    <Switch />
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} sm={7}>
              <Typography variant="h6" color="textPrimary">
                Agent transactions
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setSelectedAgent({ ...selectedAgent, open: false });
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

     

      {/* Dialogs ends here */}
      <Box display="flex">
        <Box mr={2}>
          <PermIdentity color="primary" fontSize="large" />
        </Box>
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h5">
            <b>Agents</b>
          </Typography>
          <Box ml={1} mr={1} mt={1}>
            <ArrowForwardIos fontSize="small" />
          </Box>
          <Typography variant="h6">Managers</Typography>
        </Box>
      
      </Box>
      <Box mt={3} />

      {agents.loading && <LinearProgress />}
      <MUIDataTable
        title={"List of system agents"}
        data={agents.data}
        columns={columns}
        options={options}
      />
    </div>
  );
}



export default withLocalize(AgentManagers);
